import { render, staticRenderFns } from "./PricingListItem.vue?vue&type=template&id=099bface&scoped=true&"
import script from "./PricingListItem.vue?vue&type=script&lang=js&"
export * from "./PricingListItem.vue?vue&type=script&lang=js&"
import style0 from "./PricingListItem.vue?vue&type=style&index=0&id=099bface&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099bface",
  null
  
)

export default component.exports